import cn from 'clsx';
import {Button} from '@chekin/guestapp-ui-kit';
import styles from './styles.module.css';

type Props = {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  label?: string;
  hidden?: boolean;
};

function PayButton({className, disabled, onClick, label, hidden}: Props) {
  if (hidden) {
    return null;
  }

  return (
    <div className={cn(styles.paymentBox__row, className, 'checkout-summary-box__row')}>
      <Button
        className="w-full checkout-summary-box__button"
        disabled={disabled}
        onClick={onClick}
      >
        {label}
      </Button>
    </div>
  );
}

export {PayButton};
